module.exports = __webpack_public_path__ + "img/17.54638007.jpg";